const $ = require('jquery');

jQuery(document).ready(function () {

    // @see http://openweathermap.org/weather-conditions
    var icon_mapping = {
        '01d': 'sunny',         // clear sky day
        '01n': 'night',         // clear sky night
        '02d': 'cloudy-day',    // few clouds day
        '02n': 'cloudy-night',  // few clouds night
        '03d': 'overcast',      // scattered clouds day
        '03n': 'overcast',      // scattered clouds night
        '04d': 'overcast',      // broken clouds day
        '04n': 'overcast',      // broken clouds night
        '09d': 'rain-alt',      // shower rain day
        '09n': 'rain-alt',      // shower rain night
        '10d': 'rain',          // rain day
        '10n': 'rain',          // rain night
        '11d': 'lighting',      // thunderstorm day
        '11n': 'lighting',      // thunderstorm night
        '13d': 'snow',          // snow day
        '13n': 'snow',          // snow night
        '50d': 'breeze',        // mist day
        '50n': 'breeze'         // mist night
    };
    var $weather_container = jQuery('.hero-current-weather');

    if (1 === $weather_container.length) {
        // Current weather element present, get the weather
        jQuery.get(
            dbk_weather.rest_api_url,
            {
                post_id: $weather_container.data('post-id')
            },
            function (data) {
                data = JSON.parse(data);
                if ('200' == data.cod) {
                    $weather_container.find('.weather-type').text(data.weather[0].description);
                    $weather_container.find('.weather-temperature').html(Math.ceil(data.main.temp) + '&deg;');

                    if (data.weather[0].icon in icon_mapping) {
                        jQuery($weather_container).find('.weather-icon i').remove();
                        var icon = jQuery('<i/>');
                        icon.addClass('fi').addClass('flaticon-' + icon_mapping[data.weather[0].icon]);
                        jQuery($weather_container).find('.weather-icon').append(icon);
                    }

                    $('.hero-current-weather').fadeIn();
                }
            }
        );
    }

});